var unitPrice = "{{ pricePerUnit }} por unidad";
var unitsCount = "{{ unitsCount }} unidades";
var unitCount = "{{ unitsCount }} unidad";
var unitPriceWithQuantity = "{{ pricePerUnit }} por unidad / {{ unitsCount }} unidades";
var vatInclusive = "IVA incl.";
var vatExclusive = "IVA no incl.";
var excludeShipping = "{{ shipping }} no incl.";
var includeShipping = "{{ shipping }} incl.";
var shipping = "envío";
var vatAndShipping = {
	includeVatExcludeShipping: "IVA incl., {{ shipping }} no incl.",
	excludeVatIncludeShipping: "IVA no incl., {{ shipping }} incl.",
	includeVatIncludeShipping: "IVA incl., {{ shipping }} incl.",
	excludeVatExcludeShipping: "IVA no incl., {{ shipping }} no incl."
};
var priceSummary = "Resumen del precio";
var priceSummaryInfoIcon = "Icono de información de resumen del precio";
var priceSummaryModal = "Modal de resumen del precio";
var priceSummaryCloseModal = "Cerrar el modal de resumen del precio";
var priceSummaryTermsAndConditions = "* Para cada pedido, se fabrica una malla para serigrafía o un tampón único y el equipo se ajusta para imprimir tu diseño. ";
var priceSummaryBasePrice = "Precio base";
var priceSummarySetupFee = "Tarifa de personalización especial*";
var priceSummarySubtotal = "Subtotal";
var differentialPrice = {
	included: "Incluido",
	forUnits: "{{ differentialPrice }} por {{ quantity }} unidades",
	forUnit: "{{ differentialPrice }} por {{ quantity }} unidad"
};
var priceFrom = "Desde {{ price }}";
var volumeDiscount = "{{volumeDiscount}} % de descuento por volumen";
var volumeDiscountPlusSale = "{{volumeDiscount}} % de descuento por volumen + oferta";
var rangePrice = "{{xx}} - {{yy}}";
var unitRangePrice = "{{rangePrice}} la unidad";
var originalPrice = "precio original:";
var salePrice = "precio con descuento:";
var setupFee = "Se aplica una tarifa de personalización especial de {{ setupFee }}";
var noSetupFee = "Sin tarifa de personalización especial";
var vatAndSetupFee = {
	noVatInclSetup: "Incl. tarifa de personalización especial de {{ setupFee }}",
	inclVatAndSetup: "Incl. tarifa de personalización especial de {{ setupFee }} e IVA",
	exclVatInclSetup: "Incl. tarifa de personalización especial de {{ setupFee }}; IVA no incluido",
	inclVatSetupInclShipping: "Incl. tarifa de personalización especial de {{ setupFee }} e IVA; incl. {{ shipping }}",
	inclVatSetupExclShipping: "Incl. tarifa de personalización especial de {{ setupFee }} e IVA, {{ shipping }} no incluido",
	exclVatSetupInclShipping: "Incl. tarifa de personalización especial de {{ setupFee }}; IVA no incluido; incl. {{ shipping }}",
	exclVatSetupExclShipping: "Incl. tarifa de personalización especial de {{ setupFee }}; IVA y {{ shipping }} no incluidos"
};
var eses = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee
};

export { eses as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFrom, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
//# sourceMappingURL=ep-pricing-esm-localization-texts-es-es.json.js.map
